import { Path } from 'enums';
import UsersModule from 'modules/users/users.module';

import React from 'react';
import { Route, Switch } from 'react-router-dom';

const UsersPage = () => {
  return (
    <Switch>
      <Route exact path={Path.Users} component={UsersModule} />
    </Switch>
  );
};

export default UsersPage;
